import React from "react";
import { Label } from "@/components/ui/label";

// Mirrors openhouse_api_engine.py — $0.00499/listing + one ~$0.09 actor start.
export const RESULT_PRICE_USD = 0.00499;
export const ACTOR_START_USD = 0.09;
export const estimateCost = (n) => Math.round((ACTOR_START_USD + n * RESULT_PRICE_USD) * 100) / 100;

export default function ScanBudgetControls({ maxResults, onMaxResults, usdCap, onUsdCap }) {
  const estimate = estimateCost(maxResults);
  const capTooLow = usdCap < estimate;
  return (
    <div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label htmlFor="scan-max-results" className="text-xs uppercase tracking-wide text-slate-600 flex items-center justify-between">
            <span>Max listings</span>
            <span className="text-slate-400 font-mono">{maxResults}</span>
          </Label>
          <input
            id="scan-max-results"
            type="range"
            min="50"
            max="300"
            step="50"
            value={maxResults}
            onChange={(e) => onMaxResults(Number(e.target.value))}
            className="w-full mt-2 accent-rose-600"
            data-testid="scan-max-results"
          />
          <div className="text-[10px] text-slate-500 mt-0.5">
            You only pay for listings actually found
          </div>
        </div>
        <div>
          <Label htmlFor="scan-usd-cap" className="text-xs uppercase tracking-wide text-slate-600 flex items-center justify-between">
            <span>Budget cap</span>
            <span className="text-slate-400 font-mono">${usdCap.toFixed(2)}</span>
          </Label>
          <input
            id="scan-usd-cap"
            type="range"
            min="0.10"
            max="3.00"
            step="0.05"
            value={usdCap}
            onChange={(e) => onUsdCap(Number(e.target.value))}
            className="w-full mt-2 accent-rose-600"
            data-testid="scan-usd-cap"
          />
          <div className="text-[10px] text-slate-500 mt-0.5">
            Hard limit enforced by Apify
          </div>
        </div>
      </div>
      <div
        className={"mt-2 text-[11px] rounded-md px-2.5 py-1.5 border " + (capTooLow
          ? "border-amber-200 bg-amber-50 text-amber-900"
          : "border-slate-200 bg-slate-50 text-slate-600")}
        data-testid="scan-cost-estimate"
      >
        Worst case <span className="font-semibold tabular-nums">${estimate.toFixed(2)}</span> for {maxResults} listings
        (≈ {(RESULT_PRICE_USD * 100).toFixed(1)}¢ each + ${ACTOR_START_USD.toFixed(2)} start).
        A typical Saskatoon weekend is 40–50 listings ≈ $0.30.
        {capTooLow ? " Your cap is below the worst case — results may be cut short." : ""}
      </div>
    </div>
  );
}
